export const STATE_GAME: string = "State_Game";
export const STATE_SELECTION: string = "State_Selection";
export const STATE_RESULTS: string = "State_Results";
export const STATE_CIRCUS: string = "State_Circus";

export const LOAD_SPLASH: string = "Load_Splash";
export const LOAD_INTERSTITIAL: string = "Load_Interstitial";

export const SPRITESHEET_UI: string = "ui";
export const SPRITESHEET_GAMEPLAY: string = "gameplay";
export const SPRITESHEET_TERRAIN_PREFIX: string = "terrain-";
export const SPRITESHEET_OBSTACLE_PREFIX: string = "obstacles-";
export const SPRITESHEET_CIRCUS_PREFIX: string = "circus-";

export const FONT_LUNA: string = "luna";
export const FONT_GEL_PEN_MED_35: string = "gelPenMedium35";

export const FUN_FACT_GENERIC_PLACEHOLDER: string = "FunFactGenericPlaceholder";

export const DEBUG_SKIP_LOAD: boolean = false;
export const DEBUG_MINIMAL_AUDIO: boolean = false;
export const DEBUG_DEFAULT_STATE: string | undefined = undefined;
export const DEBUG_SKIP_ONBOARDING: boolean = false;

export const PARALLAX_SPEED: number = -125;
export const LEVEL_SIZE: number = 12000;
export const ONBOARDING_SIZE: number = 3250;
